<button nz-button nzSize="large" nz-tooltip="Download CSV" (click)="onDownload()">
	<nz-icon nzType="download" />
</button>
